export default class InitialLoadingError extends Error {
  protected extraData: { [key: string]: any };

  constructor(message: string, extra?: { [key: string]: any }) {
    super();
    this.name = 'InitialLoadingError';

    this.message = message || 'Initial loading error!';

    this.extraData = extra || {};

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, InitialLoadingError);
    }
  }
}
